import { h, Component, Fragment} from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {Form, I18n, Button, FormEntry, Col, Row, Divider, Container, Toggle} from 'components/elements' 
import {connect} from 'react-redux'
import {
    PatientActions, 
    SelectedTimeSlotActions,
	SelectedPatientActions,
    PageActions,
	AvailabilityActions
} from 'actions'
import { ProcessTimeSlots } from 'lib/helpers'
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';
import _ from 'lodash'

// Icons
import editIcon from "../../../assets/icons/svg/edit.svg";
import leftChevron from "../../../assets/icons/svg/chevron_left.svg";
import rightChevron from "../../../assets/icons/svg/chevron_right.svg";

let mapInputType = {
	String: 'text',
	Dropdown: 'text',
	Integer: 'number',
	Float: 'number'
}

@Form
@connect((state)=>({
	...state
}))
export default class PatientInformation extends WidgetComponent {
	constructor(props){
		super(props)
		this.state = {
            editing: false,
            error: '',
			classificationID: '',
			age: {},
			customBooleans: {}
		}

		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleToggleEdit = this.handleToggleEdit.bind(this)
		this.handleBreedChange = this.handleBreedChange.bind(this)
		this.handleClassificationChange = this.handleClassificationChange.bind(this)
		this.handleMonthAgeChange = this.handleMonthAgeChange.bind(this)
		this.handleYearAgeChange = this.handleYearAgeChange.bind(this)
		this.handleNegativeCheck = this.handleNegativeCheck.bind(this)
		this.handlePatientUpdate = this.handlePatientUpdate.bind(this)
		this.handleColorChange = this.handleColorChange.bind(this)
        this.validateTimeSlot = this.validateTimeSlot.bind(this)
		this.handleReturnToTimeSlots = this.handleReturnToTimeSlots.bind(this)
	}

	componentWillMount(){
		if(this.props.editing){
			this.setState({
				editing: this.props.editing,
				classificationID: this.props.patient.classificationID
			})
		}	

		let customBooleans = {}
		for(let customField of this.customFields){
			if(customField.type == 'Boolean'){
				customBooleans[customField.key] = this.patient[customField.key] || false
			}
		}

		this.setState({
			customBooleans
		})
	}

	handleSubmit(values){
		if(this.componentIsLoading()){
			return
        }
        
        this.setState({
            error: ''
        })
		
		if(values.reason && Object.keys(values).length == 1){
			PatientActions.append({
				...this.patient,
				...values
			})
			this.componentWillSubmit().then((response)=>{
				this.handlePatientUpdate({
					...this.patient,
					...values
				})
			})
			return
		}
		
		if(this.state.age.years != undefined || this.state.age.months != undefined){
			let birthday = dayjs();
			let y, m;

			if(this.state.age.years != undefined){
				y = parseInt(this.state.age.years || '0')
			}else{
				y = this.patient.age.years
			}

			if(this.state.age.months != undefined){
				m = parseInt(this.state.age.months || '0')
			}else{
				m = this.patient.age.months
			}

			birthday = birthday.subtract(m, 'month')
			birthday = birthday.subtract(y, 'year')

			values.birthday = birthday.toDate();
		}

		let data = {
			...this.patient,
			...values,
			...this.state.customBooleans
		}

		if(data.weight && !data.weightUnit){
			data.weightUnit = this.weightUnit
		}

		if(!data.birthday){
			return false
		}

		PatientActions.append(data)
		if(this.newPatient){
			this.componentWillSubmit().then((response)=>{
				return PatientActions.create({...this.patient}).then((response)=>{
					if(this.state.editing){
						this.handleToggleEdit()
					}
					
					for(let key of Object.keys(this.props.FormData)){
						delete this.props.FormData[key]
					}
                    this.validateTimeSlot()
					super.componentDidSubmit()
					this.props.onSubmit && this.props.onSubmit(response.data)
				}).catch((e)=>{
					this.componentFailedToSubmit()
                    this.setState({
                        error: _.get(e, 'response.data.errors', e)
                    })
				})
			})
		} else {
			this.componentWillSubmit().then((response)=>{
				return PatientActions.update({
					...data,
					...this.patient
				}).then((response)=>{
                    this.validateTimeSlot()
					this.handlePatientUpdate({
						...response.data,
						...values
					})
				}).catch((e)=>{
                    this.componentFailedToSubmit()
                    this.setState({
                        error: (e.response.data || {}).errors || ''
                    })
                    console.log((e.response.data || {}).errors || '')
				})
			})
		}
	}

    validateTimeSlot(){
        if(!this.props.config.placeholderAppointment && this.hasRestrictions){
            let selectedTimeSlot = {
                ...this.props.selectedTimeSlot,
                startsAt: dayjs(this.props.selectedTimeSlot.startsAt),
                endsAt: dayjs(this.props.selectedTimeSlot.endsAt)
            }
    
            if(selectedTimeSlot.invalid){
                return false
            }
    
            let availabilities = Object.entries(this.props.availabilities || {}).map(([, _])=> _ )
            let patientIDs = Object.keys(this.props.selectedPatients)
            let patients = Object.values(this.props.patients).filter((patient)=> patientIDs.includes(patient.id))
            
            let serviceRegionIDs
            if(Object.keys(this.props.serviceRegions).length > 0){
                serviceRegionIDs = Object.keys(this.props.serviceRegions)
            } 
    
            let timeSlots = ProcessTimeSlots.all({
                startingAt: selectedTimeSlot.startsAt.format(),
                data: availabilities, 
                shifts: this.props.shifts,
                widgetAvailability: this.organization.widgetAvailability,
                appointmentType: this.props.appointmentTypes[this.props.filters.appointmentTypeID],
                patientCount: this.props.filters.patientCount,
                administrators: this.props.administrators,
                serviceRegionIDs,
                patients
            })
            let selectedAdminTimeslots = timeSlots[selectedTimeSlot.administratorID]
    
            if(!selectedAdminTimeslots[`${selectedTimeSlot.administratorID}--S${selectedTimeSlot.startsAt.format("YYYY-MM-DD-HH-mm-ss")}--E${selectedTimeSlot.endsAt.format("YYYY-MM-DD-HH-mm-ss")}`]){
                SelectedTimeSlotActions.set({
                    invalid: true
                })
            } 
        }
    }

	handlePatientUpdate(data){
		if(this.state.editing){
			this.handleToggleEdit()
		}
		
		for(let key of Object.keys(this.props.FormData)){
			delete this.props.FormData[key]
		}

		super.componentDidSubmit()
		this.props.onSubmit && this.props.onSubmit(data)
	}

	get patient(){
		let patient = {
			...(this.props.patient || {})
		}
		if(!patient.age){
			patient.age = {
				years: 0,
				months: 0,
			}
		}
		if(patient.birthday){
			const totalMonths = dayjs().diff(patient.birthday, "month")
			const years = Math.floor(totalMonths / 12)
			const months = totalMonths - (years * 12)
			patient.age = {
				years,
				months
			}
		}
		return patient
	}

	get newPatient(){
		return /newPatient/.test(this.patient.id)
	}

	get genders(){
		const genders = Object.entries(this.props.genders || {}).map(([, _])=> _ )
		return genders.map((_)=>({
			name: _.name,
			value: _.id
		}))
	}

	get gender(){
		return this.props.genders[this.patient.genderID] || {}
	}
	
	get classifications(){
		let siblingID = this.classification.siblingID
		const classifications = Object.entries(this.props.classifications || {}).map(([, _])=> _ )
			.filter((c)=>(c.active))
		
		return classifications.map((_)=>({
			name: _.name,
			value: _.id
		}))
	}

	get classification(){
		return this.props.classifications[this.state.classificationID || this.breed.classificationID || this.patient.classificationID] || {}
	}

	get breeds(){
		let siblingID = this.breed.siblingID
		const breeds = Object.values(this.props.breeds || {})
			.filter((breed)=>{return (!this.classification || breed.classificationID == this.classification.id) && breed.active})

		return breeds.map((_)=>({
			name: _.name,
			value: _.id
		})) || []
	}

	get breed(){
		return this.props.breeds[this.patient.breedID] || {}
	}

	get organization(){
		return this.props.organization || {}
	}

	get weightUnit(){
		let weightUnit = this.patient.weightUnit
		if(!weightUnit){
			switch(this.organization.country){
				case "US":
					return I18n.t('lbs')
				case "CA":
					return I18n.t('kg')
				default:
					return I18n.t('lbs')
			}
		}
		return I18n.t(weightUnit)
	}

	get customFields(){
		return Object.values(this.props.customFields || {}).filter((customField)=>{
			return customField.model == 'Patient'
		}).sort((a,b)=>{
			if(a.type == 'Boolean') return 1
			if(b.type == 'Boolean') return -1
			return 0
		})
	}

    get showReason(){
        let showReason = !(this.props.config.reason || {}).hide
        if(_.isNil(showReason)) showReason = true
        
        return showReason
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }

	handleToggleEdit(){
		this.setState({
			editing: !this.state.editing
		})
	}

	handleClassificationChange(data){
		this.setState({
			classificationID: data
		})
	}

	handleBreedChange(data){
		this.setState({
			breedID: data
		})
	}

	handleYearAgeChange(e){
		const age = {...this.state.age}
		age.years = e.target.value

		this.setState({
			age
		})
	}
	
	handleMonthAgeChange(e){
		const age = {...this.state.age}
		age.months = e.target.value

		this.setState({
			age
		})
	}
	
	handleColorChange(e){
		let color = e.target.value

		this.setState({
			color
		})
	}

	handleNegativeCheck(e){
		if(String.fromCharCode(e.keyCode) == '-'){ 
		   e.preventDefault() 
		}
	}

	handleToggleCustomField(customField, e){
		this.setState({
			customBooleans: {
				...this.state.customBooleans,
				[customField.key]: !this.state.customBooleans[customField.key]
			}
		})
	}

	get showBirthDateSelect(){
		return _.get(this, 'organization.settings.widget.patients.birthdate', false)
	}

	handleReturnToTimeSlots(){
		if(this.hasRestrictions){
			AvailabilityActions.clear()
			SelectedTimeSlotActions.set({});
		}else {
			SelectedPatientActions.clear()
		}
        PageActions.navToTimeSlots();
    }

	render(){
		const {Form, InputDark, SelectDark, DatePickerDark} = this.props
		let submitPrompt = this.state.editing?(
			<I18n>update</I18n>
		):this.newPatient?(
			<I18n>create</I18n>
		):(
			<I18n>next</I18n>
		)
		return (
			<Container type={this.props.type} title={this.props.title} class={style.petInformationContainer}>
				<Form for={this.patient.id || 'newPatient'} class={style.patientsForm} onSubmit={this.handleSubmit}>
					<div className={style.patientsContainer} >
						<div className={style.patientsContainerHeader}>
							<div className={style.textHeader}>
								<label>
									<I18n>petInformation</I18n>
								</label>
							</div>
							{!this.newPatient && 
								(
									<div class={style.editText}>
										<Button type='button' theme={"gray"} onClick={this.handleToggleEdit}>
											<img src={editIcon} alt="Edit Icon"/>
											<span>
												{
													this.props.patient && this.state.editing
													? <I18n>cancel</I18n> 
													:<I18n>edit</I18n>
												 }
											</span>
										</Button>
									</div>
								)
							}
						</div>
						<div className={style.patientsContainerBody}>
							<div className={style.patientInfo}>
								<Row class={style.infoRow}>
									<Col class={style.infoCol}>
										<label>
											{I18n.t("patientName").toUpperCase()}
										</label>
										{
											this.state.editing 
											? (
												<FormEntry>
													<InputDark required={true} type='text' name='firstName' id='firstName' question={I18n.t("patientName")} initialValue={this.patient.firstName} />
												</FormEntry>
											)
											: (
												<label>
													{this.patient.firstName }
												</label>
											)
											
										}
									</Col>
								</Row>
								<Row class={`${style.infoRow} ${style.grid}`}>
									{!this.newPatient && !this.state.editing?(
										<Col class={style.infoCol}>
												{this.showBirthDateSelect?(
													<div>
														{dayjs(this.patient.birthday).format('MM/DD/YYYY')}
													</div>
												):(
													<Fragment>
														<label>
															{I18n.t("age").toUpperCase()}
														</label>
														<label>
															{!!this.patient.age.years && <span>
																{this.patient.age.years} year(s)
															</span>}
															{!!this.patient.age.years && !!this.patient.age.months && <span>
															{", "}
															</span>}
															{!!this.patient.age.months && <span>
																{this.patient.age.months} month(s)
															</span>}
														</label>
													</Fragment>
												)}
										</Col>
									):(
										this.showBirthDateSelect ? (
											<Col class={style.infoCol}>
												<label>
													{I18n.t("birthdate").toUpperCase()}
												</label>
												<FormEntry>
													<DatePickerDark 
														class={style.inputWithLabel} 
														required={true}
														name='birthday'
														question={I18n.t("birthdate")}
														initialValue={this.patient.birthday}
														max={dayjs()}
														
													/>
												</FormEntry>
											</Col>
										) : [
											<Col class={style.infoCol}>
												<label>
													{I18n.t("age").toUpperCase()}
												</label>
												<FormEntry>
													<label class={style.inputLabel}>
														<I18n>years</I18n>
													</label>
													<InputDark
														class={style.inputWithLabel}
														required={true}
														type='number'
														name='ageYears'
														min='0'
														question={I18n.t("age")}
														initialValue={this.patient.age.years}
														onchange={this.handleNegativeCheck}
														onChange={this.handleYearAgeChange} 
													/>
												</FormEntry>
											</Col>,
											<Col class={style.infoCol}>
												<label>
													&nbsp;
												</label>
												<FormEntry>
													<label class={style.inputLabel}>
														<I18n>months</I18n>
													</label>
													<InputDark 
														class={style.inputWithLabel} 
														required={true}
														type='number'
														name='ageMonths'
														min='0'
														question={I18n.t("age")}
														initialValue={this.patient.age.months}
														onchange={this.handleNegativeCheck}
														onChange={this.handleMonthAgeChange}
													/>
												</FormEntry>
											</Col>
										]
									)}
									<Col class={style.infoCol}>
										<label>
											{I18n.t("weight").toUpperCase()}
										</label>
										{
											!this.newPatient && !this.state.editing 
											? (
												<label>
													{`${this.patient.weight || 'None' } ${(this.patient.weight && this.weightUnit) || ""}` }
												</label>
											)
											: (
												<FormEntry>
													<label class={style.inputLabel}>
														{this.weightUnit}
													</label>
													<InputDark 
														class={style.inputWithLabel} 
														required={true} 
														type='number' 
														min='0'
														name='weight' 
														id='weight' 
														question={I18n.t("weight")} 
														initialValue={this.patient.weight} 
														step="any"
													/>
												</FormEntry>
											)
											
										}
									</Col>
								</Row>
								<Row class={`${style.infoRow} ${style.grid}`}>
									<Col class={style.infoCol}>
											<label>
												{I18n.t("sex").toUpperCase()}
											</label>
											{
												!this.newPatient && !this.state.editing
												? (
													<label>
														{this.gender.name ? I18n.t(this.gender.name.toLowerCase()) : 'None'}
													</label>
												)
												: (
													<FormEntry>
														<SelectDark 
															required={true} 
															data={this.genders} 
															name='genderID' 
															placeholder={I18n.t("gender")}
															initialValue={this.patient.genderID} />
													</FormEntry>
												)
											}
									</Col>
									<Col class={style.infoCol}>
										<label>
											{I18n.t("species").toUpperCase()}
										</label>
										{
											!this.newPatient && !this.state.editing
											? (
												<label>
													{this.classification.name || 'None'}
												</label>
											)
											: (
												<FormEntry>
													<SelectDark required={true} 
														data={this.classifications} 
														name='classificationID' 
														placeholder={I18n.t("species")}
														initialValue={this.patient.classificationID || this.breed.classificationID} 
														onChange={this.handleClassificationChange}/>
												</FormEntry>
											)
										}
									</Col>
								</Row>
								<Row class={`${style.infoRow} ${style.grid}`}>
									<Col class={style.infoCol}>
											<label>
												{I18n.t("breed").toUpperCase()}
											</label>
											{
												!this.newPatient && !this.state.editing
												? (
													<label>
														{this.breed.name || 'None'}
													</label>
												)
												: (
													<FormEntry>
														<SelectDark 
															required={true} 
															data={this.breeds} 
															name='breedID' 
															question={I18n.t("breed")}
															initialValue={this.patient.breedID} 
															onChange={this.handleBreedChange}
															dropDownLength={5}
														/>
													</FormEntry>
												)
											}
									</Col>
									<Col class={style.infoCol}>
										<label>
											{I18n.t("color").toUpperCase()}
										</label>
										{
											!this.newPatient && !this.state.editing
											? (
												<label>
													{this.patient.color || 'None'}
												</label>
											)
											: (
												<FormEntry >
													<InputDark
														required={true}
														type='text'
														name='color'
														question='Color'
														initialValue={this.patient.color}
														onChange={this.handleColorChange} 
													/>
												</FormEntry>
											)
										}
									</Col>
								</Row>
								{this.customFields.length > 0 && (
									<Row class={style.infoRow}>
										{this.customFields.map((customField)=>{
											if(!this.newPatient && !this.state.editing && !this.patient[customField.key] && !customField.required){
												return
											}
											return (
												<Col class={style.infoCol}>
													<label class={`${style.colTitle} ${style.invertColor}`}>
														{I18n.t("extraFields").toUpperCase()}
													</label>

													{!this.newPatient && !this.state.editing?
														<div className={style.labelContainer}>
															<label className={style.item}>
																<span className={style.itemTitle}>{customField.label}</span>
																<span  className={style.otherInfo}>{!_.isNil(this.patient[customField.key]) ? `${this.patient[customField.key]}` : 'none'}</span>
															</label>
														</div>
													:
														<div class={style.inputsContainer}>
															<Col class={style.item}>
																{customField.type !== 'Boolean' &&
																	<div className={style.itemTitle}>
																		{customField.label}
																	</div>
																}
																<FormEntry >
																	{customField.type == 'Boolean' &&
																		<Toggle class={style.customToggle} selected={this.state.customBooleans[customField.key]} onSelect={this.handleToggleCustomField.bind(this, customField)}>
																			{customField.label}
																		</Toggle>
																	}
																	{customField.dropdownOptions && customField.dropdownOptions.length > 0 &&
																		<SelectDark 
																			required={customField.required} 
																			name={customField.key}
																			id={customField.key} 
																			data={customField.dropdownOptions} 
																			placeholder={customField.label} 
																			initialValue={this.patient[customField.key]} 
																		/>
																	}	
																	{(!customField.dropdownOptions || customField.dropdownOptions.length == 0) && customField.type != 'Boolean' &&
																		<InputDark
																			required={customField.required}
																			type={mapInputType[customField.type]}
																			step={customField.type == 'Float' && .01}
																			name={customField.key}
																			question={customField.label}
																			initialValue={this.patient[customField.key]}
																			onChange={this.handleColorChange} 
																		/>
																	}
																</FormEntry>
															</Col>
														</div>
													}
												</Col>
											)
										})}
									</Row>
                            	)}
								{this.showReason && this.props.selectedTimeSlot.id && 
									<Row class={style.infoRow}>
										<Col class={style.infoCol}>
											<label>
												{I18n.t("reasonForVisit").toUpperCase()}
											</label>
											{
												this.patient.reason && !this.state.editing
												? (
													<label>
														{this.patient.reason || 'None'}
													</label>
												)
												: (
													<FormEntry >
														<InputDark 
														required={true} 
														type='text' 
														name='reason' 
														id='reason' 
														question={I18n.t("reasonForVisit")}
														initialValue={this.patient.reason} />
													</FormEntry>
												)
											}
										</Col>
									</Row>
								}
							</div>
						</div>
					</div>

					{!this.newPatient || this.state.editing &&
						<Divider />
					}


					{this.state.error &&
						<div class={style.errorMessage}>{this.state.error}</div>	
					}

					<div className={style.formButtons}>
						{ !this.props.config.hideBackButton && (this.props.selectedTimeSlot.id && !this.patient.reason) &&
							<Button type="button" theme="gray" spinner={this.componentIsLoading()} onClick={this.handleReturnToTimeSlots}>
								<img src={leftChevron} alt="Left Chevron"/>
								<I18n>back</I18n>
							</Button>
						}
						{((this.props.selectedTimeSlot.id && !this.patient.reason) || this.newPatient || this.state.editing) && 
							<Button spinner={this.componentIsLoading()}>
								{submitPrompt}
								<img src={rightChevron} alt="Right Chevron"/>
							</Button>
						}	
					</div>
				</Form>
			</Container>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientInformation/index.js